import {ComputedReservationDetailsContextProps} from '../context/computedReservationDetails';
import {PATHS} from '../Routes';

type FinishURLProps = {
  reservationDetails: ComputedReservationDetailsContextProps;
  locationState?: any;
  skip?: {
    hasUpselling?: boolean;
    hasDeposit?: boolean;
  };
};

function getFinishCheckinHistoryArgs({
  reservationDetails,
  locationState,
  skip,
}: FinishURLProps) {
  if (!skip?.hasDeposit && reservationDetails.hasDeposits) {
    return {
      url: PATHS.protect,
      state: locationState,
    };
  }

  if (reservationDetails.hasTaxes) {
    return {
      url: PATHS.touristTaxes,
      state: locationState,
    };
  }

  if (reservationDetails.isSomePayments || reservationDetails.hasTaxes) {
    return {
      url: PATHS.pay,
      state: locationState,
    };
  }

  return {
    url: PATHS.finish,
    state: locationState,
  };
}

function getNewGuestUrl(reservationDetails: ComputedReservationDetailsContextProps) {
  const {hasBiomatch, hasScanDocument, isLeaderGuest} = reservationDetails;

  if (isLeaderGuest) {
    return {
      url: PATHS.confirmBooking,
      state: null,
    };
  }
  if (hasBiomatch || hasScanDocument) {
    return {
      url: PATHS.verificationStart,
      state: null,
    };
  }
  return {
    url: PATHS.formPersonalData,
    state: null,
  };
}

export {getFinishCheckinHistoryArgs, getNewGuestUrl};
